import { render, staticRenderFns } from "./ReportAccidentDetails.vue?vue&type=template&id=4060e5b0&scoped=true"
import script from "./ReportAccidentDetails.vue?vue&type=script&lang=ts"
export * from "./ReportAccidentDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReportAccidentDetails.vue?vue&type=style&index=0&id=4060e5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060e5b0",
  null
  
)

export default component.exports